import dayjs from "dayjs";

/** Calendar days from today to the event's start day: 0 today, 1 tomorrow. */
export const daysUntilEvent = (startsAt: string, now = dayjs()) =>
  dayjs(startsAt).startOf("day").diff(now.startOf("day"), "day");

/** An event that starts at 5 PM or later is "tonight", not "today". */
export const startsInEvening = (startsAt: string) => dayjs(startsAt).hour() >= 17;

/**
 * "Today · 7:00 PM", "Tomorrow · 7:00 PM", "Saturday · 7:00 PM" within the
 * week, then "Sat, Oct 17 · 7:00 PM". `tonight` says "Tonight" for an evening
 * event today, for the surfaces an attendee checks on the day.
 */
export function formatEventWhen(
  startsAt: string,
  { tonight = false }: { tonight?: boolean } = {}
): string {
  const d = dayjs(startsAt);
  const time = d.format("h:mm A");
  const days = daysUntilEvent(startsAt);
  if (days === 0) {
    return `${tonight && startsInEvening(startsAt) ? "Tonight" : "Today"} · ${time}`;
  }
  if (days === 1) return `Tomorrow · ${time}`;
  if (days > 1 && days < 7) return `${d.format("dddd")} · ${time}`;
  return d.format("ddd, MMM D · h:mm A");
}
